settingLink = angular.module('name.setting', [])

settingLink.directive "linkSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "ContentEditable", ($window, $timeout, $compile, $templateCache, ns, ContentEditable) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  link: (scope, element, attrs, ngModel) ->

    id = scope.data.id
    widgetElWrapper = angular.element("[data-block-id=#{id}]").find ns.widgetWrapperClass

    setLinkHtml = (newVal) ->
      if newVal.link_type is "default"
        if widgetElWrapper.find(".strwf_button_default").length is 0
          scope.data.style_attributes.textAlign = "center"
          scope.data.style_attributes.backgroundColor = "rgba(255, 255, 255, 0)"
          scope.data.button_attributes.style_attributes.padding = "10px 10px 10px 10px"
          scope.data.button_attributes.style_attributes.backgroundColor = "rgba(255, 255, 255, 0)"
          scope.data.button_attributes.style_attributes.color = "#4A90E2"
          scope.data.button_attributes.style_attributes.borderRadius = "0px"
          widgetElWrapper.find(".strwf_button").eq(0).replaceWith "<a href='#' contenteditable='false' spellcheck='false' data-access='button_attributes.value' class='strwf_button strwf_button_default link-anchor'>#{newVal.button_attributes.value}</a>"
        widgetElWrapper.find(".strwf_button").eq(0).css newVal.button_attributes.style_attributes
      else
        if widgetElWrapper.find(".strwf_button_full").length is 0

          scope.data.style_attributes.backgroundColor = "rgba(0, 0, 0, 0.7)"
          scope.data.button_attributes.style_attributes.padding = "13px 20px 13px 20px"
          scope.data.button_attributes.style_attributes.backgroundColor = "rgba(255, 255, 255, 1)"
          scope.data.button_attributes.style_attributes.color = "rgba(0, 0, 0, 1)"
          scope.data.button_attributes.style_attributes.borderRadius = "20px"
          widgetElWrapper.find(".strwf_button").eq(0).replaceWith "<a class='strwf_button strwf_button_full link-anchor' href='#' >
            <div class='str-link__content'>
              <span class='str-link__text' contenteditable='false' spellcheck='false' data-access='text'>#{newVal.text}</span>
                <button class='str-link__button' contenteditable='false' data-access='button_attributes.value' spellcheck='false'>#{newVal.button_attributes.value}</button>
            </div>
          </a>"
        widgetElWrapper.find(".strwf_button_full").css {backgroundImage: "url(#{newVal.image_attributes.source_url})"}
        widgetElWrapper.find(".str-link__text").css newVal.text_style
        widgetElWrapper.find(".str-link__button").css newVal.button_attributes.style_attributes
      ContentEditable.bind false, true, id
    listener = scope.$watch "data", (newVal) ->
      setLinkHtml newVal
    , true


    scope.$on "$destroy", ->
      listener()
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/link/link.directive.coffee